"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceDefaultsContext = void 0;
const react_1 = require("react");
exports.EvidenceDefaultsContext = (0, react_1.createContext)({});
//# sourceMappingURL=evidence-defaults-context.js.map